import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import ACCOUNT_SETTINGS_CONTROLLER from '../../controllers/accountSettings';
import LANGUAGES_CONTROLLER from '../../controllers/languages';

import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import AccountSettingsForm from './AccountSettingsForm';
import FileSaveAs from '../downloaders/FileSaveAs';
import AuthorizedResource from '../authorization/AuthorizedResource';
import authorize from '../../utils/auth';

import Logger, { ALL_MESSAGES, LOG_LEVELS } from '../../utils/logger';
const log = new Logger('ACCOUNT_SETTINGS_PAGE', LOG_LEVELS.DEBUG);

class Page extends Component {

  constructor(props){
    super(props);
    this.onExportAccountSettingsData = this.onExportAccountSettingsData.bind(this);
  }

  onExportAccountSettingsData () {
    log.debug('onExportAccountSettingsData()');
    return new Promise((resolve, reject)=>{
      this.props.doExportAccountSettings((err, data)=>{
        if(err){
          reject(err);
          return;
        }
        const downloadData = {
          content: data || '', ext: 'xml'
        };
        resolve(downloadData);
      });
    });
  }

  render() {
    log.debug('render(): ', this.props);

    return (
    <div className="content-area">
        <s-container>
            <h1>{LANGUAGES_CONTROLLER.format(this.props.languages, 'TitleSettings')}</h1>
            <ApplicationMessages messageType="applicationSuccess" messageIds={[ALL_MESSAGES.FILE_IMPORT_SUCCESS]} className="mt0 mb0" />
            <ApplicationMessages messageType="applicationError"
              messageIds={[ALL_MESSAGES.FILE_IMPORT_ERROR,
                ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_FORBIDDEN,
                ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_TOO_LONG,
                ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_TOO_LONG,
                ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_FORBIDDEN,
                ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_FORBIDDEN,
                ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_MISMATCH]}
              />
          {
            this.props.accountSettings ? (
              <AccountSettingsForm
                settings={this.props.accountSettings}
                onSubmit={this.saveSettings.bind(this)}
                onCancel={this.cancelEdit.bind(this)}
              />
            ) : (<div></div>)
          }
          <div className="mt10 mb10">
            <FileSaveAs
                downloadLabel="Export Account Settings" 
                fetchContent={this.onExportAccountSettingsData}
                filename={`AccountSettings-${moment.utc().format('YYYY-MM-DD')}`}  
                mimeType="application/xml"
                charset="utf-8"
                isBlob={true}    
            />
          </div>
          <div className="clear"></div>
        </s-container>
    </div>
    );
  }
  saveSettings(settings) {
    log.debug('saveSettings(): ', settings);
    // Note: we don't need to process the structure of the settings, since it is already happily in a suitable structure.
    // TODO: we could however filter the settings to only those which have changed from the inital settings.
    this.props.doSaveSettings(settings, () => {
      log.debug('saveSettings().finished: reloading...');
      this.props.onPageLoad();
    });
  }
  cancelEdit() {
    log.debug('cancelEdit(): ');
    // TODO: not sure what to do here. Nothing? Navigate elsewhere?
  }
  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    this.props.onPageLoad();
  }
  componentDidMount() {
    log.debug('componentDidMount()');
    log.clearAllDictionaryErrors();
  }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {
    languages: state.languages,
    accountSettings: state.accountSettings && state.accountSettings.data,
    exportAccountSettingsData: state.accountSettings && state.accountSettings.exportAccountSettingsData
  };
}

function mapDispatchersToProps(dispatch) {
  return {
    onPageLoad: () => {
      dispatch(ACCOUNT_SETTINGS_CONTROLLER.doLoad());
    },
    doSaveSettings: (settings, done) => {
      dispatch(ACCOUNT_SETTINGS_CONTROLLER.doUpdate(settings, done));
    },
    doExportAccountSettings: (callback=()=>{}) => {
      log.debug("doExportAccountSettings(): ")
      dispatch(ACCOUNT_SETTINGS_CONTROLLER.doExport(callback));
    }
  }
}

export default  authorize({
  name: 'AccountSettings',
  resource: connect(mapStateToProps, mapDispatchersToProps)(Page)
}, AuthorizedResource, {
  showNotAuthorized: true
});

// Wrap the component to inject dispatch and state into it
//export default connect(mapStateToProps, mapDispatchersToProps)(Page);
